/**
 * Prototype-only: which royalty-rates presentation the contract details view uses,
 * so the two can be compared side by side without a rebuild. Switched from the dev
 * bar and persisted, so a refresh keeps the reviewer on the variant they picked.
 *
 * Scaffolding for the contract-royalty-rates prototype — delete with the rest of
 * src/prototypes/contract-royalty-rates/ and the marked lines in main.tsx.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const RATES_VARIANTS = {
  strip: "A · Rates strip",
  tab: "B · Rates tab",
} as const;

export type RatesVariant = keyof typeof RATES_VARIANTS;

/** How the rates read inside variant B's tab. Only meaningful when variant is "tab". */
export const RATES_LAYOUTS = {
  table: "Table",
  cards: "Cards",
} as const;

export type RatesLayout = keyof typeof RATES_LAYOUTS;

type RatesVariantState = {
  variant: RatesVariant;
  layout: RatesLayout;
  setVariant: (variant: RatesVariant) => void;
  setLayout: (layout: RatesLayout) => void;
};

export const useRatesVariant = create<RatesVariantState>()(
  persist(
    (set) => ({
      // A is the default: the strip is the shipped-looking option.
      variant: "strip",
      layout: "table",
      setVariant: (variant) => set({ variant }),
      setLayout: (layout) => set({ layout }),
    }),
    { name: "prototype-royalty-rates-variant" },
  ),
);
